import React from "react";
import { Link } from "react-router-dom";
import { useSiteContent } from "@/contexts/SiteContentContext";

export default function Footer() {
  const { content } = useSiteContent();
  const c = content.contact;
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-[#FAF5E8] pt-16 pb-8 relative overflow-hidden"
    >
      {/* huge corner mark */}
      <div
        aria-hidden="true"
        className="absolute -bottom-12 -right-6 font-display select-none pointer-events-none"
        style={{
          fontSize: "clamp(8rem, 22vw, 22rem)",
          lineHeight: 0.8,
          color: "rgba(255,255,255,0.05)",
        }}
      >
        R⋆TAMA
      </div>

      <div className="max-w-[1500px] mx-auto px-5 lg:px-8 relative">
        {/* Top */}
        <div className="grid grid-cols-12 gap-10 border-b border-[#FAF5E8]/20 pb-12">
          <div className="col-span-12 lg:col-span-5">
            <Link
              to="/"
              data-testid="footer-logo"
              className="font-display text-6xl lg:text-7xl tracking-tight inline-block"
            >
              R⋆TAMA
            </Link>
            <p className="font-hand text-3xl text-[#FFD500] mt-3 max-w-md leading-tight">
              we build creator careers.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF5B17] mb-4">
              ✶ Studio
            </div>
            <ul className="space-y-2.5 font-mono text-sm">
              <li><a href="/#platforms" className="hover:text-[#FFD500] transition-colors">Platforms</a></li>
              <li><a href="/#services" className="hover:text-[#FFD500] transition-colors">Services</a></li>
              <li><a href="/#worldwide" className="hover:text-[#FFD500] transition-colors">Worldwide</a></li>
              <li><a href="/#contact" className="hover:text-[#FFD500] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF5B17] mb-4">
              ✶ Legal
            </div>
            <ul className="space-y-2.5 font-mono text-sm">
              <li>
                <Link
                  to="/privacy"
                  data-testid="footer-privacy"
                  className="hover:text-[#FFD500] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  data-testid="footer-terms"
                  className="hover:text-[#FFD500] transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  data-testid="footer-cookies"
                  className="hover:text-[#FFD500] transition-colors"
                >
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-12 lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF5B17] mb-4">
              ✶ Office
            </div>
            <address
              data-testid="footer-address"
              className="not-italic font-mono text-sm text-[#FAF5E8]/85 leading-relaxed"
            >
              {c.address_line_1}<br />
              {c.address_line_2}
            </address>
            <a
              href={`mailto:${c.email}`}
              className="inline-block mt-4 font-mono text-sm bg-[#FFD500] text-[#0A0A0A] px-2 py-0.5 hover:bg-[#FF2D9C] hover:text-[#FAF5E8] transition-colors"
            >
              {c.email}
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#FAF5E8]/55">
          <div>© {year} RTAMA LTD · made in Cyprus · sent worldwide</div>
          <div className="flex items-center gap-6">
            <span>Set in Big Shoulders &amp; Caveat</span>
            <span className="font-hand text-base normal-case tracking-normal text-[#FFD500]">
              thx for scrolling ✶
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
